/* LYORA mobile gallery dots (Nov 2026).
   Adds a row of dots under the swipeable product gallery on mobile.
   Counts only the photos that are visible for the selected colour and
   rebuilds when the gallery changes (variant switch). */
(function () {
  function visibleItems(list) {
    return Array.prototype.filter.call(list.querySelectorAll('.product__media-item'), function (item) {
      return window.getComputedStyle(item).display !== 'none';
    });
  }

  function setup(wrapper) {
    var list = wrapper.querySelector('.product__media-list');
    if (!list || wrapper.dataset.lyoraDots) return;
    wrapper.dataset.lyoraDots = 'true';

    var dots = document.createElement('div');
    dots.className = 'lyora-gallery-dots';
    dots.setAttribute('aria-label', 'Product images');
    list.closest('slider-component').insertAdjacentElement('afterend', dots);

    function activeIndex() {
      var width = list.clientWidth || 1;
      return Math.round(list.scrollLeft / width);
    }

    function render() {
      var items = visibleItems(list);
      dots.innerHTML = '';
      dots.hidden = items.length < 2;
      items.forEach(function (item, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'lyora-gallery-dots__dot';
        dot.setAttribute('aria-label', 'Show image ' + (index + 1) + ' of ' + items.length);
        dot.addEventListener('click', function () {
          list.scrollTo({ left: index * list.clientWidth, behavior: 'smooth' });
        });
        dots.appendChild(dot);
      });
      update();
    }

    function update() {
      var current = activeIndex();
      Array.prototype.forEach.call(dots.children, function (dot, index) {
        var active = index === current;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    var ticking = false;
    list.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }, { passive: true });

    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(render, 80);
    }).observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    window.addEventListener('resize', update);
    render();
  }

  function init() {
    document.querySelectorAll('.lyora-product-page .product__media-wrapper').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* PDP "Size and fit" accordion: "View size guide" opens the same size guide as the size picker. */
(function () {
  if (window.__lyoraSizeGuideLink) return;
  window.__lyoraSizeGuideLink = true;
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-lyora-open-size-guide]');
    if (!link) return;
    var trigger = document.querySelector('[data-af-open]');
    if (trigger) {
      event.preventDefault();
      trigger.click();
    } else {
      window.location.href = '/pages/size-chart';
    }
  });
})();
